@if (column().type === "checkbox") {
    <div class="px-4 py-2">
        <app-checkbox-column [(selecteds)]="selecteds" />
    </div>
} @else {
    @let isOpenMenu = column().field !== "rowNumber";

    <button
        [cdkMenuTriggerFor]="isOpenMenu ? menu : null"
        [ngClass]="{ 'cursor-default': !isOpenMenu }"
        class="px-4 py-2 w-full flex"
    >
        {{ column().name }}
    </button>
}

<ng-template #menu>
    <app-menu cdkMenu>
        <app-menu-option
            cdkMenuItem
            (click)="handleOrderBy('desc')"
            icon="ic:outline-arrow-downward"
            [active]="orderBy() === column().field && align() === 'desc'"
            >내림차순</app-menu-option
        >
        <app-menu-option
            cdkMenuItem
            (click)="handleOrderBy('asc')"
            icon="ic:outline-arrow-upward"
            [active]="orderBy() === column().field && align() === 'asc'"
            >오름차순</app-menu-option
        >
        <app-divider />
        @if (column().filter?.enabled) {
            <div class="p-2.5 min-w-[15rem] flex flex-col gap-2">
                <p class="text-[11px] font-semibold text-gray-400 px-1">필터</p>
                @if (column().type === "enum" || column().type === "boolean") {
                    <app-select
                        [value]="filters()[column().field]"
                        (valueChange)="handleFilter($event)"
                        [options]="filterOptions()"
                        placeholder="전체"
                        size="sm"
                    />
                } @else {
                    <app-input
                        [value]="filters()[column().field]"
                        (valueChange)="handleFilter($event)"
                        [placeholder]="column().name + ' 필터'"
                        size="sm"
                        [type]="column().type === 'number' ? 'number' : 'text'"
                    />
                }
            </div>
        }
    </app-menu>
</ng-template>
